"use client";

import React, { FC } from "react";
import { graphql, PageProps } from "gatsby";
import { Blog } from "@app/components/blog/Blog";

type PageContext = {
  pageContext: {
    category?: string;
  };
};

const InsightsPage: FC<PageProps & PageContext> = ({ pageContext }) => (
  <Blog category={pageContext.category} />
);

export default InsightsPage;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
